document.addEventListener('DOMContentLoaded', function() {
    var sliderElement = document.getElementById('brandsSlider');

    // Inicializamos Tiny Slider
    var slider = tns({
        container: sliderElement,
        items: 3,
        slideBy: 1,
        autoplay: true,
        autoplayTimeout: 1500, // Tiempo entre cada desplazamiento (en milisegundos)
        speed: 1600, // Velocidad de cada desplazamiento (en milisegundos)
        autoplayHoverPause: false, // El carrusel no se detendrá cuando el mouse esté sobre él
        mouseDrag: true,
        loop: true,
        controls: false, // Desactiva los controles predeterminados (botones anterior/siguiente)
        nav: false, // Desactiva la navegación predeterminada (puntos)
        swipeAngle: false,
        controls: false,
        responsive: {
            768: {
                items: 5
            }
        }
    });
});